// Copyright (c) 2020 Deere & Company
import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LinkedOrderDifferencesTable from './components/linked-order-differences-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLinkedOrderDifferences } from './repositories';
import { setAgGridLicense } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class LinkedOrderDifferences extends Component {

    state = {
        results: []
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        setAgGridLicense();

    }

    componentDidMount = () => {

        this.refresh();

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    refresh () {

        this.props.increaseCounter();
        getLinkedOrderDifferences()
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            results
        } = this.state;
        const additionalInfo = ( results !== null ? {
            unitName: this.props.unit.name
        } : '' );
        const linkedOrderDiffrencesResult = results.map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                <header>
                    <h2 className="page-header">Linked Order Differences</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-linked-order-differences-top-options">

                            <div className="export-button">
                                {linkedOrderDiffrencesResult.length > 0 && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <LinkedOrderDifferencesTable
                            results={linkedOrderDiffrencesResult}
                            ref={this.child}
                        />
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

LinkedOrderDifferences.displayName = 'LinkedOrderDifferences';
LinkedOrderDifferences.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( LinkedOrderDifferences ) );
